import { render } from "./WildBookEntryCoordinates.vue?vue&type=template&id=37d7e665&scoped=true&ts=true"
import script from "./WildBookEntryCoordinates.vue?vue&type=script&lang=ts"
export * from "./WildBookEntryCoordinates.vue?vue&type=script&lang=ts"

import "./WildBookEntryCoordinates.vue?vue&type=style&index=0&id=37d7e665&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d7e665"]])

export default __exports__